import react, { useEffect } from 'react'
import { MdOutlinePerson } from 'react-icons/md'
import styled from 'styled-components'
import Job from '../../Common/Job'
import { MdSettings } from 'react-icons/md'
import Group from '../../Common/Group'
import Reply from '../../Common/Reply'
import { Inventory } from '../../../models/Inventory'
import { JobSimple } from '../../../models/JobSimple'
import MenteeInventoryGrid from './MenteeInventoryGrid'
import MenteeInventoryListItem from './MenteeInventoryListItem'
import { GridView, ViewList } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { asyncGetInventories, setInInventory } from '../../../store/mainSlice'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { setIsInventoryGrid, UserState } from '../../../store/userSlice'
import { InventoryReplyFormValues } from '../../Popup/InventoryReplyForm'
import { Link } from 'react-router-dom'
import { setIn } from 'formik'

// type Props = {
//   inventories: Inventory[]
//   setInventories: (inventories: Inventory[]) => void
// }

function Main() {
  const dispatch = useAppDispatch()

  const me = useAppSelector((state: RootState) => state.user.me)
  const jobs = useAppSelector((state: RootState) => state.main.jobs)
  const setting = useAppSelector((state: RootState) => state.user.me.setting)
  const reducerInventories = useAppSelector(
    (state: RootState) => state.main.inventories
  )

  const [isGridClicked, setIsGridClicked] = react.useState(
    setting?.isInventoryShowGrid ?? true
  )
  const [payMin, setPayMin] = react.useState(0)
  const [payMax, setPayMax] = react.useState(0)
  const [pointMax, setPointMax] = react.useState(0)
  const [likeMax, setLikeMax] = react.useState(0)
  const [recommendMax, setRecommendMax] = react.useState(0)
  const [inventories, setInventories] = react.useState<Inventory[]>([])

  useEffect(() => {
    if (inventories && inventories.length === 0) {
      dispatch(asyncGetInventories())
    }
  }, [])

  useEffect(() => {
    const invs = [...reducerInventories]
    invs.sort((a: Inventory, b: Inventory) => b.point - a.point)
    setInventories(invs)
  }, [reducerInventories])

  useEffect(() => {
    setIsGridClicked(setting.isInventoryShowGrid)
  }, [setting])

  useEffect(() => {
    dispatch(setIsInventoryGrid(isGridClicked))
  }, [isGridClicked])

  const handleViewStyleClick = (gridClick: boolean) => {
    setIsGridClicked(gridClick)
  }

  useEffect(() => {
    if (!inventories) {
      return
    }
    if (inventories.length > 0) {
      const minLower: number[] = inventories.map(
        (inventory: Inventory) => inventory.job.payLower
      )
      const minUpper: number[] = inventories.map(
        (inventory: Inventory) => inventory.job.payUpper
      )
      const maxPoint: number[] = inventories.map(
        (inventory: Inventory) => inventory.point
      )
      const maxLike: number[] = inventories.map(
        (inventory: Inventory) => inventory.likeCnt
        //inventory.replies.reduce((acc, reply) => acc + reply.like, 0)
      )
      const maxRecommend: number[] = inventories.map(
        (inventory: Inventory) => inventory.recommendCnt
      )

      setPayMin(Math.min(...minLower))
      setPayMax(Math.max(...minUpper))
      const pm = Math.max(...maxPoint)
      setPointMax(pm === 0 ? 1 : pm)
      const lm = Math.max(...maxLike)
      setLikeMax(lm === 0 ? 1 : lm)
      const rm = Math.max(...maxRecommend)
      setRecommendMax(rm === 0 ? 1 : rm)
    }
  }, [inventories])

  return (
    <Container>
      <Title>
        <div>나의 직업 인벤토리</div>
        <div>
          <IconButton
            onClick={() => handleViewStyleClick(true)}
            style={{
              background: isGridClicked ? '#eee' : 'white',
              transition: 'all 0.2s ease-in-out',
            }}
          >
            <GridView />
          </IconButton>
          <IconButton
            onClick={() => handleViewStyleClick(false)}
            style={{
              background: !isGridClicked ? '#eee' : 'white',
              transition: 'all 0.2s ease-in-out',
            }}
          >
            <ViewList />
          </IconButton>
        </div>
      </Title>
      <Content className="mentor">
        {inventories && inventories.length > 0 ? (
          inventories
            //.sort((a: Inventory, b: Inventory) => b.point - a.point)
            .map((inventory: Inventory, index: number) =>
              isGridClicked ? (
                <MenteeInventoryGrid
                  key={index}
                  inventory={inventory}
                  inventories={inventories}
                  isShowRemoveInventory={true}
                  user={me}
                ></MenteeInventoryGrid>
              ) : (
                <MenteeInventoryListItem
                  key={index}
                  inventory={inventory}
                  inventories={inventories}
                  //setInventories={props.setInventories}
                  payMin={payMin}
                  payMax={payMax}
                  pointMax={pointMax}
                  recommendMax={recommendMax}
                  likeMax={likeMax}
                  isShowMemo={true}
                  user={me}
                  // onSubmitReply={onSubmitReply}
                />
              )
            )
        ) : (
          <NotExist>
            <div>인벤토리에 추가된 직업이 없습니다.</div>
            <div>
              직업을 검색해서 나에게 맞는 직업을 인벤토리에 추가해보세요.
            </div>
            <div style={{ marginTop: '1rem' }}>
              <Link to="/mentee/search">직업검색</Link>
            </div>
          </NotExist>
        )}
      </Content>
    </Container>
  )
}

const Container = styled.div`
  grid-area: main;
  margin-bottom: 1rem;
  width: 1400px;
  margin: 0 auto;
  padding-top: 20px;
  @media (max-width: 768px) {
    width: 100%;
  }
`

const Title = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
`

const Content = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
  row-gap: 20px;
  padding-bottom: 100px;
`
const NotExist = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 100px;
  font-size: 1.2rem;
`
export default Main
